import(/* webpackMode: "eager" */ "/app/apps/no-ga/src/app/[locale]/error.tsx");
